// extracted by mini-css-extract-plugin
export default {"introductionBox":"introduction_introductionBox__QLNvW","desBox":"introduction_desBox__YdBzR","totalBox":"introduction_totalBox__O93pw","open_data":"introduction_open_data__YrT3i"};